import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent {
	activeModal = inject(NgbActiveModal);

	@Input() bodyMsg1: string="";
  @Input() bodyMsg2: string="";
  @Input() title: string="";
  @Input() submitButton: string="";
  lang: string="";
}
